import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx/src/nx.module';
import { from } from 'rxjs';
import { map ,  switchMap } from 'rxjs/operators';

import { fromCamelToDash } from '../../../../../helpers/';
import { GITLAB_COMPANY_PL } from '../../../../constants/';
import { GetCompleteAction } from '../../../../ngrx/actions/root.action';
import { AppState } from '../../../../ngrx/state';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import { IntegrationNames } from '../../../core/integraition-list';
import * as integrations from '../../../core/store/integration.action';
import { removeByIdsFn } from '../../../settings/slack-alert/util/uninstall';
import { ESGitlabCompany } from '../../models/git-company';
import * as gitlabCompany from './gitlab-company.actions';
import * as fromGitlabCompany from './gitlab-company.reducer';

@Injectable()
export class GitlabCompanyEffects {
  private key = fromCamelToDash(GITLAB_COMPANY_PL);

  defaultErrorHandler(action, error) {
    console.error('effect', action, error);
  }

  @Effect()
  getMany$ = this.data.fetch(gitlabCompany.GET_INDEX, {
    run: (action, store) =>
      this.api.get([this.key]).pipe(
        map(jsonApiToEntityState),
        switchMap((state: ESGitlabCompany) => {
          let id;
          const actions: any[] = [
            new GetCompleteAction(state),
            new gitlabCompany.GetIndexComplete(state[GITLAB_COMPANY_PL])
          ];
          if ((id = this.getFirstId(state[GITLAB_COMPANY_PL]))) {
            actions.push(
              new integrations.IntegrationStatusUpdated({ name: IntegrationNames.Gitlab, isInstalled: true })
            );
            actions.push(new gitlabCompany.SetActive(id));
          }

          return from(actions);
        })
      ),
    onError: this.defaultErrorHandler
  });

  @Effect()
  removeAll$ = this.data.pessimisticUpdate(gitlabCompany.REMOVE_ALL, {
    run: (action, store) => {
      const ids = fromGitlabCompany.getIds(store);
      return this.remover(ids).pipe(
        switchMap(_ =>
          from([
            new gitlabCompany.RemoveAllComplete(),
            new integrations.IntegrationStatusUpdated({ name: IntegrationNames.Gitlab, isInstalled: false })
          ])
        )
      );
    },
    onError: (action, error) => {
      this.defaultErrorHandler(action, error);
    }
  });

  constructor(private data: DataPersistence<AppState>, private api: AtlazApiV2Service) {}

  private remover = removeByIdsFn(this.api, this.key);

  private getFirstId(state: ESGitlabCompany) {
    return state && state.ids[0];
  }
}
